@use "../../styles/text";
@use "../../styles/icon-sizes";
@use "../../styles/breakpoints";
@use "../../styles/content-container";

// <label /> not allowed inside shadow DOM so hp6-text-select is `shadow: false`
hp6-text-select {
  --option-width: auto;
  --label-width: 0px;

  background-color: transparent;
  display: inline-flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;

  hp6-label-decorator {
    margin-right: var(--spacing-xxs);
    white-space: nowrap;
  }

  select {
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: transparent;
    color: var(--color-link-base);
    z-index: 1;
    cursor: pointer;
  }

  hp6-icon {
    --system-color: var(--color-link-base);
    position: absolute;
    right: 0;
    display: none;
  }

  &:hover {
    select {
      color: var(--color-link-dark);
    }

    hp6-icon {
      --system-color: var(--color-link-dark);
    }
  }

  &:focus {
    select {
      color: var(--color-link-dark);
    }

    hp6-icon {
      --system-color: var(--color-link-dark);
    }
  }

  &:active {
    select {
      color: var(--color-link-xdark);
    }

    hp6-icon {
      --system-color: var(--color-link-xdark);
    }
  }

  &[label-size-selection="xxs"] {
    .text-select-container {
      align-items: baseline;

      hp6-label-decorator {
        @include text.text-heading-xxs;
        min-height: var(--text-heading-line-height-xxs);
      }
    }
  }

  &.loaded {
    overflow: visible;

    hp6-label-decorator {
      white-space: inherit;
    }

    hp6-icon {
      display: inline-block;
    }
  }

  .hp6-text-select-element {
    box-sizing: border-box;
    padding-left: 3px;
    padding-right: 18px; // padding to account for the ellipsis
    outline-offset: -2px;
    outline-width: 2px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    border: 0;
    width: var(--option-width);
    max-width: calc(
      100vw - (
        var(--label-width) + var(--spacing-xxs) + #{content-container.$left + content-container.$right}
      )
    ); // label width + label-margin + content container padding (both sides)
    text-decoration: underline;
    white-space: nowrap;

    // @include breakpoints.medium-up {
    //   padding-right: 0;
    // }

    &.xxs {
      @include text.text-body-xs;
    }

    &.xs {
      @include text.text-body-sm;
    }

    &.sm {
      @include text.text-body-md;
    }

    &.md {
      @include text.text-body-lg;
    }

    &.option-measure {
      position: absolute;
      left: -9999px;
      top: 0;
      visibility: hidden;
      width: auto;
    }
  }
}
